import { render, staticRenderFns } from "./ConfirmTemplate.vue?vue&type=template&id=3ee19b58&scoped=true&"
import script from "./ConfirmTemplate.vue?vue&type=script&lang=ts&"
export * from "./ConfirmTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmTemplate.vue?vue&type=style&index=0&id=3ee19b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee19b58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
